import { Frame } from '@studiometa/ui';
import ListingPanel from './ListingPanel.js';

/**
 * Listing component
 */
export default class Listing extends Frame {
  /**
   * Component Configuration
   */
  static config = {
    ...Frame.config,
    name: 'Listing',
    components: {
      ...Frame.config.components,
      ListingPanel,
    },
    options: {
      ...Frame.config.options,
      loading: {
        type: String,
        default: '',
      },
    },
  };

  // Form element
  form = undefined;

  // Form fields
  fields = [];

  /**
   * Setup fields
   */
  setup() {
    this.form = this.$el.querySelector('form');
    this.fields = Array.from(this.$el.querySelectorAll('input, select'));
  }

  /**
   * Setup fields change listeners
   */
  setupListeners() {
    this.fields.forEach((field) => {
      field.addEventListener('change', this.onFieldsChange.bind(this));
    });
  }

  /**
   * Update the listing on fields change
   */
  onFieldsChange() {
    // Get the urlSearchParams from the form FormData
    const formData = new FormData(this.form);
    const urlSearchParams = new URLSearchParams(formData);

    // Replace search parameter with the urlSearchParams
    const url = new URL(window.location);
    url.search = urlSearchParams;

    // Go to the new url
    this.goTo(url.toString());

    // Add animations classes
    document.body.classList.add('cursor-wait');
    this.$el.classList.add(...this.$options.loading.split(' '));
  }

  /**
   * Remove the animations classes onAfterLeave
   */
  onAfterLeave() {
    // Remove animations classes
    document.body.classList.remove('cursor-wait');
    this.$el.classList.remove(...this.$options.loading.split(' '));
  }

  /**
   * Reset filters
   */
  onListingPanelReset() {
    this.fields.forEach((field) => {
      switch (field.nodeName) {
        case 'SELECT':
          field.selectedIndex = 0;
          break;
        default:
          field.value = '';
          break;
      }
    });
  }
}
